var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLoader == true)?_c('div',{staticClass:"loader-wrap"},[_c('div',{staticClass:"loader"}),_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row wrap-spinners"},[_c('div',{staticClass:"main-spinner"},[_c('div',{staticClass:"spinner-border",attrs:{"role":"status"}})])])
}]

export { render, staticRenderFns }